// src/components/common/SidePanel.tsx
import React from 'react';
import './SidePanel.css';

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  theme: 'dark' | 'light';
  children: React.ReactNode;
}

const SidePanel: React.FC<SidePanelProps> = ({ isOpen, onClose: _onClose, theme, children }) => {
  return (
    <div className={`side-panel-container ${isOpen ? 'open' : ''} ${theme}`}>
      <div className="side-panel-content" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default SidePanel;